import { render, staticRenderFns } from "./req-miles-review.vue?vue&type=template&id=248f12dc&scoped=true"
import script from "./req-miles-review.vue?vue&type=script&lang=js"
export * from "./req-miles-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f12dc",
  null
  
)

export default component.exports